export type MainTabIds = "leverages" | "all" | "challenges";
export type TextTabIds = "organization" | "team" | "leadership";
export const DEFAULT_MAIN_TAB: MainTabIds = "all";
export const DEFAULT_TEXT_TAB: TextTabIds = "organization";

export const HEIGHTS: Record<MainTabIds, { desktop: string; mobile: string }> =
  {
    all: {
      desktop: "calc(100vh - 141px - 194px)",
      mobile: "calc(100vh - 141px - 154px)",
    },
    leverages: {
      desktop: "calc(100vh - 141px - 146px)",
      mobile: "calc(100vh - 100px - 147px)",
    },
    challenges: {} as any,
  };

HEIGHTS.challenges = HEIGHTS.leverages;
